import React, { useEffect } from 'react';
import { sessionService } from '../../services/sessionService';

const SessionManager = ({ children }) => {
  useEffect(() => {
    // Check if user is authenticated
    const access_token = sessionStorage.getItem("usr_1a2b3c");
    const refresh_token = sessionStorage.getItem("usr_4d5e6f");
    const isAuthenticated = !!(access_token && refresh_token);

    // Start session monitoring when authenticated
    if (isAuthenticated) {
      sessionService.startSessionMonitoring();
    } else {
      sessionService.stopSessionMonitoring();
    }

    // Cleanup on unmount
    return () => {
      sessionService.stopSessionMonitoring();
    };
  }, []); // Run once on mount

  // Also monitor authentication changes by checking sessionStorage periodically
  useEffect(() => {
    const checkAuthInterval = setInterval(() => {
      const access_token = sessionStorage.getItem("usr_1a2b3c");
      const refresh_token = sessionStorage.getItem("usr_4d5e6f");
      const isAuthenticated = !!(access_token && refresh_token);

      if (isAuthenticated && !sessionService.validationInterval) {
        // User just logged in, start monitoring
        console.log('✅ Authentication detected, starting session monitoring');
        sessionService.startSessionMonitoring();
      } else if (!isAuthenticated && sessionService.validationInterval) {
        // User just logged out, stop monitoring
        console.log('⏹️ Logout detected, stopping session monitoring');
        sessionService.stopSessionMonitoring();
      }
    }, 5000); // Check every 5 seconds

    return () => {
      clearInterval(checkAuthInterval);
    };
  }, []);

  return <>{children}</>;
};

export default SessionManager;


